import { render, staticRenderFns } from "./SysLanguageConfigFileList.vue?vue&type=template&id=13c1bd02&scoped=true&"
import script from "./SysLanguageConfigFileList.vue?vue&type=script&lang=js&"
export * from "./SysLanguageConfigFileList.vue?vue&type=script&lang=js&"
import style0 from "./SysLanguageConfigFileList.vue?vue&type=style&index=0&id=13c1bd02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1bd02",
  null
  
)

export default component.exports